import styled from 'styled-components';

export const TrainerContent = styled.div`
    width: 359px;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddTrainerModal/style.js